import { colors } from '../../colors';
var imageGallery = {
  primaryColor: colors.white,
  bgColor: colors.red,
  tileBgColor: colors.white,
  iconBgColor: colors.red
};
export default imageGallery;